import { NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { featherChevronRight } from '@ng-icons/feather-icons';
import { TranslatePipe } from '@ngx-translate/core';
import { LayoutService } from 'src/app/services/layout/layout.service';

@Component({
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  standalone: true,
  selector: 'app-breadcrumb',
  imports: [NgClass, RouterLink, NgIconComponent, TranslatePipe],
  viewProviders: [provideIcons({ featherChevronRight })],
})
export class BreadcrumbComponent {
  private readonly layoutService = inject(LayoutService);

  get breadcrumbs() {
    return this.layoutService.breadcrumbs;
  }
}
